module.exports = __webpack_public_path__ + "img/glogg.0fca3f91.jpg";